import { TenantFragment } from "src/state/gql/_types"
import { FormSchema } from "src/utils/forms"

export type SuperAdminTenantCreateFragment = Omit<TenantFragment, 'id' | 'status' | 'type' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'tenant_status' | 'tenant_type'  >

export const SuperAdminTenantCreateSchema: FormSchema<SuperAdminTenantCreateFragment> = {
    id: "tenant",
    title: "Tenant",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        name: {
            group: 'default',
            label: "Name",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        address_line1: {
            group: 'default',
            label: "Address Line 1",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        address_line2: {
            group: 'default',
            label: "Address Line 2",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        city: {
            group: 'default',
            label: "City",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        state: {
            group: 'default',
            label: "State",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        postal_code: {
            group: 'default',
            label: "Postal Code",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        phone: {
            group: 'default',
            label: "Phone",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        timezone: {
            group: 'default',
            label: "Timezone",
            type: "timezone-select",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        }
    }
}

export type SuperAdminTenantUpdateFragment = Omit<TenantFragment, 'id' | 'status' | 'type' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'tenant_status' | 'tenant_type' >

export const SuperAdminTenantUpdateSchema: FormSchema<SuperAdminTenantUpdateFragment> = {
    id: "tenant",
    title: "Tenant",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        name: {
            group: 'default',
            label: "Name",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        address_line1: {
            group: 'default',
            label: "Address Line 1",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        address_line2: {
            group: 'default',
            label: "Address Line 2",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        city: {
            group: 'default',
            label: "City",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        state: {
            group: 'default',
            label: "State",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        postal_code: {
            group: 'default',
            label: "Postal Code",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        phone: {
            group: 'default',
            label: "Phone",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        timezone: {
            group: 'default',
            label: "Timezone",
            type: "timezone-select",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        }
    }
}